(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7279],{

/***/ 17279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ItineraryMap_ItineraryMap; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@react-google-maps/api/dist/esm.js
var esm = __webpack_require__(37054);
// EXTERNAL MODULE: ./src/components/models/itinerary/ItineraryMap/ItineraryMapMarker/ItineraryMapMarker.module.scss
var ItineraryMapMarker_module = __webpack_require__(61478);
var ItineraryMapMarker_module_default = /*#__PURE__*/__webpack_require__.n(ItineraryMapMarker_module);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 17 modules
var dist_esm = __webpack_require__(66290);
// EXTERNAL MODULE: ./src/app/providers/AppConfigProvider.tsx
var AppConfigProvider = __webpack_require__(43953);
;// CONCATENATED MODULE: ./src/components/models/itinerary/ItineraryMap/ItineraryMapMarker/ItineraryMapMarker.tsx






// eslint-disable-next-line react/display-name
var ItineraryMapMarker = /*#__PURE__*/ react.forwardRef(function(param, ref) {
    var marker = param.marker, item = param.extendedItineraryItem, index = param.index, isOpen = param.isOpen, openInfoWindow = param.openInfoWindow, closeInfoWindow = param.closeInfoWindow, _onLoad = param.onLoad, onLoad = _onLoad === void 0 ? function() {} : _onLoad;
    var appConfig = (0,react.useContext)(AppConfigProvider/* AppConfigContext */.J);
    var t = (0,dist_esm/* useTranslation */.$G)("common").t;
    var _icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Marker */.Jx, {
        position: marker.position,
        label: {
            text: (index + 1).toString(),
            color: "#fff",
            className: "map-marker-label"
        },
        icon: (_icon = appConfig.googleMap.marker.icon) !== null && _icon !== void 0 ? _icon : null,
        onLoad: onLoad,
        onClick: openInfoWindow,
        // @ts-ignore
        ref: ref,
        "data-tr-click": "travel_page:itinerary_map_marker:click",
        children: isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InfoWindow */.nx, {
            onCloseClick: closeInfoWindow,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ItineraryMapMarker_module_default()).root,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ItineraryMapMarker_module_default()).dateInfo,
                        children: [
                            t("travel.itinerary.day"),
                            " ",
                            item.dayString,
                            " | ",
                            item.dateString
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ItineraryMapMarker_module_default()).content,
                        children: item.title
                    })
                ]
            })
        })
    }, index);
});
/* harmony default export */ var ItineraryMapMarker_ItineraryMapMarker = (ItineraryMapMarker);

;// CONCATENATED MODULE: ./src/components/models/itinerary/ItineraryMap/ItineraryMapMarker/index.tsx


;// CONCATENATED MODULE: ./src/components/models/itinerary/ItineraryMap/ItineraryMap.tsx






// import Spiderfy from './Spiderfy'
var extractMarkers = function(items) {
    var markerPositions = [];
    items.forEach(function(item, index) {
        item.mapMarkers.map(function(mapMarker) {
            markerPositions.push({
                itemIndex: index,
                position: {
                    lat: parseFloat(mapMarker.lat),
                    lng: parseFloat(mapMarker.lng)
                }
            });
        });
    });
    return markerPositions;
};
var extractMarkerPositions = function(markers) {
    return markers.map(function(marker) {
        return marker.position;
    });
};
var containerStyle = {
    width: "100%",
    height: "400px"
};
var options = {
    mapTypeControl: false,
    streetViewControl: false,
    mapId: "fda70355fefe3861"
};
var libraries = [
    "places"
];
function ItineraryMap(param) {
    var extendedItineraryItems = param.extendedItineraryItems;
    var appConfig = (0,react.useContext)(AppConfigProvider/* AppConfigContext */.J);
    var isLoaded = (0,esm/* useLoadScript */.Db)({
        id: "tour-map",
        googleMapsApiKey: "AIzaSyBY_3O3YiD_oc6w2uIpLvg-Pt44GJe9CZI",
        libraries: libraries
    }).isLoaded;
    var markers = extractMarkers(extendedItineraryItems);
    var markerPositions = extractMarkerPositions(markers);
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), map = ref[0], setMap = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(), 2), openMarkerIndex = ref1[0], setOpenMarkerIndex = ref1[1];
    // map
    var onLoad = react.useCallback(function callback(map) {
        var bounds = new window.google.maps.LatLngBounds();
        markerPositions.forEach(function(position) {
            bounds.extend(position);
        });
        map.fitBounds(bounds);
        setMap(map);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onUnmount = react.useCallback(function callback() {
        setMap(null);
    }, []);
    (0,react.useEffect)(function() {
        if (map) {
            var bounds = new window.google.maps.LatLngBounds();
            markerPositions.forEach(function(position) {
                bounds.extend(position);
            });
            // @ts-ignore
            map.fitBounds(bounds);
            setMap(map);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        markers
    ]);
    if (!markers.length) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return isLoaded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* GoogleMap */.b6, {
        options: options,
        mapContainerStyle: containerStyle,
        onLoad: onLoad,
        onUnmount: onUnmount,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                markers.map(function(marker, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItineraryMapMarker_ItineraryMapMarker, {
                        marker: marker,
                        extendedItineraryItem: extendedItineraryItems[marker.itemIndex],
                        index: index,
                        openInfoWindow: function() {
                            return setOpenMarkerIndex(index);
                        },
                        closeInfoWindow: function() {
                            return setOpenMarkerIndex(undefined);
                        },
                        isOpen: openMarkerIndex === index
                    }, index);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Polyline */.aH, {
                    path: markerPositions,
                    options: {
                        strokeColor: appConfig.googleMap.polyline.strokeColor
                    }
                })
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
}
/* harmony default export */ var ItineraryMap_ItineraryMap = (ItineraryMap);

;// CONCATENATED MODULE: ./src/components/models/itinerary/ItineraryMap/index.tsx



/***/ }),

/***/ 61478:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"ItineraryMapMarker_root__n3Z4M","dateInfo":"ItineraryMapMarker_dateInfo__njL9g","content":"ItineraryMapMarker_content__QUPHh"};

/***/ })

}]);